import React from 'react'
import Header from "components/Headers/Header.js";
import { useState, useEffect } from "react";
import axios from 'axios'
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Card, CardHeader, CardBody, Container, Row, Col, Spinner, CardFooter, Button, Alert} from "reactstrap";
import { Form } from 'react-bootstrap';
import { format } from 'date-fns'; 
import { MapContainer, TileLayer, LayersControl, FeatureGroup, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {Link} from 'react-router-dom'

function PrescriptionMap() {

    const [loading, setLoading] = useState(true)
    const [error, setError]=useState(false)
    const [message, setMessage]=useState('')

    const [sensorsoptions, setSensorsoptions] = useState([]);
    const [sensors, setSensor] = useState('');

    const [dateoptions, setDateoptions] = useState([]);
    const [date, setDate] = useState('');

    const [sensordata, setSensordata]=useState([])

    const [automatic, setAutomatic]=useState("True")
    const [zone, setZone]=useState(2)
    const [fertilizer, setFertilizer]=useState(40)
    const [strategy, setStrategy]=useState("highwherehigh")
    const [percentage, setPercentage]=useState(20)

    const [loadingsubmit, setLoadingsubmit] = useState(true)
    const [htmlmap, setHtmlmap]=useState('')    

    const [loadingsubmitdownload, setLoadingsubmitdownload]=useState(true)

    const token = useSelector((state) => state.userLogin.userInfo.token);

    ////////////
    const { t, i18n } = useTranslation();  

    useEffect(() => {
        const storedLanguage = localStorage.getItem('selectedLanguageAFS');
        if (storedLanguage) {
        i18n.changeLanguage(storedLanguage);
        }
    }, [i18n]);
    ////////////

    useEffect(() => {

        const fetchData = async () => {

            try {
                const config = {
                    headers: {
                        'Content-type': 'application/json',
                        Authorization: `Bearer ${token}`
                    }
                }
                
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/list/`, config);
                
                setSensorsoptions(response.data)

            } catch (error) {

            } finally {
                setLoading(false)
            }
        };

        fetchData(); 
    }, [token]);

    const handleSelectChange1 = async (e) => {
        
        setSensor(e.target.value)
        
        const sensorselected = e.target.value

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/date-sensor-data-acquisition/${sensorselected}`, config);
               
            setDateoptions(response.data);

        } catch (error) {
        }
    };

    const handleSelectChange2 = async (e) => {
        setDate(e.target.value)

        const dateselected = e.target.value

        try {

            const config = {
                headers: {
                    'Content-type': 'application/json',
                    Authorization: `Bearer ${token}`
                }
            }
            
            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/sensor-data-by-date/${sensors}/${dateselected}`, config);
            
            setSensordata(response.data);

        } catch (error) {
        }

    }

    const redIcon = new L.Icon({
        iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        popupAnchor: [1, -34],
        shadowSize: [41, 41],
    });

    const submit = async(e) => {
        
        setLoadingsubmit(false)

        if (sensors==='') {
            setMessage(t('The sensor is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (date==='') {
            setMessage(t('The date is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (fertilizer==="") {
            setMessage(t('Please set the fertilizer amount'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (fertilizer===0) {
            setMessage(t('The fertilizer must be different than 0'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (percentage==="") {
            setMessage(t('Please set the percentange of difference between the zones'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        if (percentage===0) {
            setMessage(t('The fertilizer must be different than 0'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 
        
        if (percentage>1000) {
            setMessage(t('The fertilizer must be lower than 1000'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true);
            return;
        } 

        try {

            const config = {
                headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
                }
            }; 
                
            const response_map = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/html-widget-prescription-map/${sensors}/${date}/${automatic}/${zone}/${fertilizer}/${strategy}/${percentage}/`, config);

            setHtmlmap(response_map.data)

        } catch (error) {
            setMessage(t("Some problems occured, please retry and if the problem persists please send an email to info@automaticfarmsolution.com"))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmit(true)
            return;
        } finally {
            setLoadingsubmit(true)
        }

    }

    const submitdownload = async(e) => {

        setLoadingsubmitdownload(false)

        if (sensors==='') {
            setMessage(t('The sensor is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        if (date==='') {
            setMessage(t('The date is empty'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        if (fertilizer==="") {
            setMessage(t('Please set the fertilizer amount'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        if (fertilizer===0) {
            setMessage(t('The fertilizer must be different than 0'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        if (percentage==="") {
            setMessage(t('Please set the percentange of difference between the zones'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        if (percentage===0) {
            setMessage(t('The fertilizer must be different than 0'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        
        if (percentage >= 100) {
            setMessage(t('The fertilizer must be lower than 1000'))
            setError(true)
            setTimeout(function() {
                setError(false)
            }, 5000);
            setLoadingsubmitdownload(true);
            return;
        } 

        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`
                },
                responseType: 'blob'  // Imposta la risposta come Blob
            };

            const response = await axios.get(`${process.env.REACT_APP_BACKEND_API}/sensors/download-prescription-map/${sensors}/${date}/${automatic}/${zone}/${fertilizer}/${strategy}/${percentage}/`, config);

            // Crea un oggetto Blob con i dati binari della risposta
            const blob = new Blob([response.data], { type: 'application/zip' });

            // Crea un URL oggetto per il blob
            const url = window.URL.createObjectURL(blob);

            // Crea un link temporaneo
            const link = document.createElement('a');
            link.href = url;

            // Imposta il nome del file da scaricare
            link.setAttribute('download', 'Rx.zip');

            // Aggiunge il link al documento e simula un clic per avviare il download
            document.body.appendChild(link);
            link.click();

            // Rimuove il link temporaneo dal documento
            document.body.removeChild(link);

            // Rilascia l'URL dell'oggetto per il blob
            window.URL.revokeObjectURL(url);

        } catch (error) {
            setMessage(t("Some problems occurred, please retry."));
            setError(true);
            setTimeout(() => setError(false), 5000);
            setLoadingsubmitdownload(false);
        } finally {
            setLoadingsubmitdownload(true);
        }

    }

    return (
        <div>
            <Header/>
            {loading ? (
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                            <Spinner>
                                {t('Loading')}
                            </Spinner>
                        </Col>
                    </Row>
                </Container>
            ):(
                <Container className="mt--15" fluid>
                    <Row>
                        <Col xs={12} sm={12} md={5} lg={5} xl={5} xxl={5} className="text-center mt-5">
                            <Card>
                                <CardHeader>
                                    <h3>{t('Prescription Map Setting')}</h3>
                                </CardHeader>
                                <CardBody>
                                    <Form>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select the sensor')}</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                onChange={handleSelectChange1} 
                                                value={sensors}>
                                                    <option key={""} value={""}>
                                                        
                                                    </option>
                                                    {sensorsoptions.map((farmer, index) => (
                                                        <option key={index} value={farmer.id}>
                                                            {farmer.id}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group>   
                                        <br></br>
                                        <Form.Group controlId="exampleForm.SelectCustom">
                                            <Form.Label>{t('Select the date')}</Form.Label>
                                            <Form.Control 
                                                as="select" 
                                                onChange={handleSelectChange2}
                                                value={date}>
                                                    <option key={""} value={""}>
                                                        
                                                    </option>
                                                    {dateoptions.map((farmer, index) => (
                                                        <option key={index} value={farmer.date}>
                                                            {format(new Date(farmer.date), 'PPpp')}
                                                        </option>
                                                    ))}
                                            </Form.Control>
                                        </Form.Group> 
                                        <br></br>
                                        <Form.Group controlId="AutomaticOrNot">
                                            <Form.Label>{t('Do you want to define the number of zone in Automatically way or Manual?')}</Form.Label>
                                            <Form.Control as="select"
                                                onChange={(e) => setAutomatic(e.target.value)}
                                                value={automatic}>                                                
                                                <option value="True">{t('Automatic')}</option>
                                                <option value="False">{t('Manual')}</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <br></br>
                                        <Form.Group controlId="Zone">
                                            <Form.Label>{t('If is set Manual, how many zones do you want to create?')}</Form.Label>
                                            <Form.Control as="select"
                                                onChange={(e) => setZone(e.target.value)}
                                                value={zone}
                                                >
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <br></br>
                                        <Form.Group controlId="Fertilizer">
                                            <Form.Label>{t('Max fertilizer that you want to apply?')}</Form.Label>
                                            <Form.Control 
                                                type="number" 
                                                onChange={(e) => setFertilizer(e.target.value)} 
                                                value={fertilizer}
                                            />
                                        </Form.Group>
                                        <br></br>
                                        <Form.Group controlId="Strategy">
                                            <Form.Label>{t('Which strategy do you want to use?')}</Form.Label>
                                            <Form.Control as="select"
                                                onChange={(e) => setStrategy(e.target.value)}
                                                value={strategy}
                                                >
                                                <option value="highwherehigh">{t('Provide higher amout of fertilizer where the crop is stronger')}</option>
                                                <option value="highwherelow">{t('Provide lower amout of fertilizer where the crop is stronger')}</option>
                                            </Form.Control>
                                        </Form.Group>
                                        <br></br>
                                        <Form.Group controlId="Percentage">
                                            <Form.Label>{t('Percentage of difference of fertilizer between zones')}</Form.Label>
                                            <Form.Control 
                                                type="range" 
                                                onChange={(e) => setPercentage(e.target.value)} 
                                                value={percentage} 
                                                min={0} 
                                                max={100}>

                                            </Form.Control>
                                            <p>{t('Selected Percentage:')} {percentage} %</p>
                                        </Form.Group>
                                    </Form>
                                    {error && <Alert  color="danger" fade={false}>{message}</Alert >}
                                </CardBody>
                                <CardFooter>
                                    <Row>
                                        {loadingsubmit ? (
                                            <>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                    <Button color="success" onClick={submit}>
                                                        {t('Run analysis')} <i className="fa-solid fa-code"></i>
                                                    </Button>
                                                </Col>
                                            </>
                                        ) : (
                                            <>
                                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                    <Button color="success" disabled>
                                                        <Spinner size="sm">
                                                            {t('Loading')}
                                                        </Spinner>
                                                        <span>
                                                            {' '}{t('Loading')}
                                                        </span>
                                                    </Button>
                                                </Col>
                                            </>
                                        )}
                                        <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                            <Link to="/">
                                                <Button color='primary'>
                                                    {t('Go back')} <i className="fas fa-rotate-left"></i>
                                                </Button>
                                            </Link>
                                        </Col>
                                    </Row>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col xs={12} sm={12} md={7} lg={7} xl={7} xxl={7} className="text-center mt-5">
                            {sensordata && sensordata.length>0 ? (
                                <>
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Data Points Location')}</h3>
                                        </CardHeader>
                                        <CardBody>
                                            <MapContainer key={sensordata[0].group_acquisition+sensordata[0].id} center={[sensordata[0].y_coord, sensordata[0].x_coord]} zoom={17} style={{ height: '900px', width: '100%', margin: 0, padding: 0 }}>
                                                <LayersControl position="topright">
                                                    <LayersControl.BaseLayer checked name="OpenStreetMap">
                                                        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' />
                                                    </LayersControl.BaseLayer>
                                                    <LayersControl.BaseLayer checked name="Satellite">
                                                        <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" attribution='&copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community' />
                                                    </LayersControl.BaseLayer>
                                                </LayersControl>
                                                {sensordata.map((farmer, index) => (
                                                    <FeatureGroup key={index}>
                                                        <Marker position={[farmer.y_coord, farmer.x_coord]} icon={redIcon}>
                                                            <Popup>
                                                                <p>{t('Crop :')} {t(`translation:${farmer.crop}`)}</p>
                                                                <p>{t('Number of Grape :')} {farmer.count}</p>
                                                                <p>{t('Date Time of Data Acquisition :')} {format(new Date(farmer.date), 'PPpp')}</p>        
                                                                {farmer.image1 ? <img src={farmer.image1} alt="Photo 1" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }
                                                                {farmer.image2 ? <img src={farmer.image2} alt="Photo 2" style={{ height: '50%', width: '50%', objectFit: 'cover', cursor: 'pointer' }}/> : <p>No photo saved</p> }                                
                                                            </Popup>
                                                        </Marker>
                                                    </FeatureGroup>
                                                ))}
                                            </MapContainer>
                                        </CardBody>
                                    </Card>
                                </>
                                ):null}
                        </Col>
                        {htmlmap && (   
                            <>
                                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-5">
                                    <Card>
                                        <CardHeader>
                                            <h3>{t('Prescription Map')}</h3>
                                        </CardHeader>
                                        <CardBody>                                            
                                            <iframe id="iframe3" width="100%" height="800" srcDoc={htmlmap}></iframe>
                                            <br></br>
                                            {loadingsubmitdownload ? (
                                                <>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                        <Button color="success" onClick={submitdownload}>
                                                            {t('Download')} <i class="fa-solid fa-cloud-arrow-down"></i>
                                                        </Button>
                                                    </Col>
                                                </>
                                            ) : (
                                                <>
                                                    <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="text-center mt-2">
                                                        <Button color="success" disabled>
                                                            <Spinner size="sm">
                                                                {t('Downloading')}
                                                            </Spinner>
                                                            <span>
                                                                {' '}{t('Downloading')}
                                                            </span>
                                                        </Button>
                                                    </Col>
                                                </>
                                            )}                                                                          
                                        </CardBody>
                                    </Card>
                                </Col>
                            </>
                        )}
                    </Row>
                </Container>
            )}
        </div>
    )
}

export default PrescriptionMap
